import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import SectionPage from './pages/Section';
import ChapterPage from './pages/Chapter';
import Pending from './pages/Pending';
import AdminUsers from './pages/admin/Users';
import AdminHistory from './pages/admin/History';
import AdminAudit from './pages/admin/Audit';
import AdminPublish from './pages/admin/Publish';
import AdminReadership from './pages/admin/Readership';

export default function App() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-teal/20 border-t-teal" />
      </div>
    );
  }

  if (!user) {
    if (location.pathname === '/login') {
      return <Login />;
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Reader bez oprávnění = empty state (PRD 3.2).
  // Pro MVP tuhle detekci děláme v komponentě Pending (pokud user nemá žádné readableChapterIds
  // a žádné sekce).

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/s/:sectionSlug" element={<SectionPage />} />
        <Route path="/c/:sectionSlug/:chapterSlug" element={<ChapterPage />} />
        <Route path="/c/:sectionSlug/:chapterSlug/:subSlug" element={<ChapterPage />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/history" element={<AdminHistory />} />
        <Route path="/admin/audit" element={<AdminAudit />} />
        <Route path="/admin/publish" element={<AdminPublish />} />
        <Route path="/admin/readership" element={<AdminReadership />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
